module.exports = __webpack_public_path__ + "static/zz_1-e21ed2f24d436c2b62a08b5a62727be5.png";